export enum Servers {
  RailsServer = 'rails-api',
  ApiServer = 'api-server',
  AuthServer = 'auth-server',
}

export const serverItems = [
  { name: 'Rails API', value: Servers.RailsServer },
  { name: 'API Server', value: Servers.ApiServer },
  { name: 'Auth Server', value: Servers.AuthServer },
];
